
/***
* Role Center
* - "shift-center#assign-shift",
* - "shift-center#create-shift",
* - "shift-center#default"
*/
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { GetPermissions } from '@/services/RoleCenter/GetPermissions'
import { GetFeatureFlag } from '@/services/FeatureFlags/GetFeatureFlag';
import { FeatureFlagIdEnum } from '@/enums/featureFlagIds';
import { ShiftCenterAccessLevel } from '@/enums/olympusAccessLevel';
export const useRoleCenterPermission = defineStore('roleCenterPermission', () => {

const permissionList = ref<string[]>(); 
const enableOlympus = ref<boolean>(false);
const loading = ref<boolean>(false);

  const checkUserPrivilege = async (page: keyof typeof ShiftCenterAccessLevel) => {
    
    try {
      loading.value = true;
      const featureFlagOlympus = await GetFeatureFlag(FeatureFlagIdEnum.enableOlympus);
      permissionList.value = await GetPermissions();
      enableOlympus.value = featureFlagOlympus.keyValue;
    } catch (error) {
      console.error('Error checking user privilege:', error);
    } finally {
      loading.value = false;
    }

    return hasPermission(page)
  }

  const hasPermission = (page: keyof typeof ShiftCenterAccessLevel) => {
    if (enableOlympus.value) {
      return permissionList.value.includes(ShiftCenterAccessLevel[page]);
    }

    return true
  }

  return {
    permissionList,
    enableOlympus,
    loading,
    checkUserPrivilege,
    hasPermission
  };
});
    